import React, { useState } from "react";
import { motion } from "framer-motion";
import { useMotionHook } from "../../hooks/motionHook";

function Card(props) {
  let { item, i } = props;
  const animations = useMotionHook();
  const [isOpen, setIsOpen] = useState(false);

  const handleCardClick = () => {
    addToProduct();
  };

  const addToProduct = () => {
    props.addSaleList({
      productid: item.id,
      productname: item.name,
      barcode: item.code,
      qty: 1,
      price: item.price,
      amount: item.price,
      discount: 0,
      unitdiscount: 0,
      totalamount: item.price,
      type: "plus",
    });
    if (isOpen) setIsOpen(false);
  };

  return (
    <div className="border border-borderBrey rounded-md z-10 hover:bg-primaryOpa">
      <motion.div
        {...animations}
        className="p-2 h-full flex flex-col"
        key={`${i}${item.name}`}
      >
        <div
          className="flex flex-col h-full cursor-pointer justify-between"
          onClick={handleCardClick}
        >
          <div className="flex flex-col justify-between space-between ">
            {item.code && (
              <div className="py-1 text-sm text-ellipsis overflow-hidden text-buttonBlue underline">
                {item.code}
              </div>
            )}
            <div
              className="py-1 text-lg text-ellipsis overflow-hidden"
              style={{ height: "40px" }}
            >
              {item.name}
            </div>
            <div className="flex items-end justify-between">
              <span className="text-grey mr-2 text-lg">{item.size}</span>
              <span className="text-black font-bold text-lg">
                {new Intl.NumberFormat().format(item.price)}₮
              </span>
            </div>
          </div>
        </div>
      </motion.div>
    </div>
  );
}

export default Card;
